import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { SwiperSlide } from "swiper/react";

import SwiperComponent from "../../commonComponents/SwiperComponent/SwiperComponent";
import Announcement from "./Announcement";
import IntroSection from "./IntroSection";
import AboutSection from "./AboutSection";
import RoundedButton from "../../commonComponents/RoundedButton/RoundedButton";
import { WhatWeDoSection } from "./WhatWeDoSection";
import LatestNewsSection from "./LatestNewsSection";
import LocalEvents from "./LocalEvents";
import InternationalEvents from "./InternationalEvents";
import Libraries from "./Libraries";


import {
  getAllHomeData,
  getFeaturedEvents,
  getFeaturedNews,
  getInstaFeed,
} from "../../redux/actionCreator";

import {
  featuredEventLists,
  eventLists,
  featuredNews,
  getHome_banner,
  getHome_details,
  home_loader,
  instaFeed_lists,
} from "../../redux/commonReducer";

import { API_IMAGE_URL } from "../../constants/configuration";

import "./Home.scss";
import "../PageResponsive.scss";
import "../rtl.scss";
import i18n from "../../i18n";
import { t } from "i18next";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lang, setLang] = useState(i18n?.language);

  const bannerData = useSelector(getHome_banner);
  const announcements = useSelector(featuredEventLists);
  const bannerDetails = useSelector(getHome_details);
  const loader = useSelector(home_loader);
  const featured_News = useSelector(featuredNews);

  const langSwitch = lang === "en";
  
  useEffect(() => {
    i18n.on("languageChanged", (language) => {
      setLang(language);
    });
  }, []);

  useEffect(() => {
    dispatch(getInstaFeed());
    dispatch(getAllHomeData());
    dispatch(getFeaturedNews());

    const formData = new FormData();
    formData.append("event_type", "Local");
    dispatch(getFeaturedEvents(formData));
  }, [dispatch]);

  const SwiperSlider = (
    <>
      {bannerData?.length > 0 ? (
        bannerData.map((ele, i) => (
          <SwiperSlide key={i}>
            <section
              className="humanRights__banner"
              style={{
                backgroundImage: ele?.image
                  ? `url('${API_IMAGE_URL}${ele?.file_path}${ele?.image}')`
                  : `url('./assets/img/dummy.png')`,
              }}
            >
              <div className="overlay"></div>
              <div className="banner__content animated animatedFadeInUp fadeInUp">
                <h1>{langSwitch ? ele?.title : ele?.title_ar}</h1>
                <p>{langSwitch ? ele?.desc : ele?.desc_ar}</p>
                {ele?.view_more_link && (
                  <Link to={ele?.view_more_link} target="_blank">
                  <RoundedButton
                    varient={"primary"}
                    title={t("tell me more")}
                    style={{ minWidth: "190px" }}
                  />
                </Link>
                )}
                
              </div>
            </section>
          </SwiperSlide>
        ))
      ) : (
        <section
          className="humanRights__banner"
          style={{
            backgroundPosition: "center",
            backgroundImage: `url('./assets/img/dummy.png')`,
          }}
        >
          <div className="overlay"></div>
        </section>
      )}
    </>
  );

  return (
    <Container className="home__page">
    

      {loader ? (
        <div className="banner_loader"></div>
      ) : (
        <SwiperComponent
          fade="fade"
          pagination
          data={[SwiperSlider]}
          className="home__banner"
          autoplay={{
            delay: 5000,
            disableOnInteraction: true,
          }}
        />
      )}

      {announcements?.length > 0 ? (
        <Announcement data={announcements} langSwitch={langSwitch} />
      ) : (
        <div className="mb-5"></div>
      )}

      {bannerDetails?.sub_title?.trim() !== "" &&
      bannerDetails?.sub_desc?.trim() !== "" ? (
        <IntroSection data={bannerDetails} langSwitch={langSwitch} />
      ) : null}

      <AboutSection langSwitch={langSwitch} />
      <WhatWeDoSection data={bannerDetails} />
      {featured_News?.length > 0 && <LatestNewsSection />}

      <Row>
        <Col md={12} lg={6}>
          <LocalEvents />
        </Col>
        <Col md={12} lg={6}>
          <InternationalEvents />
        </Col>
      </Row>

      <section className="humanRights__library">
        <Row>
          <Col md={12}>
            <Libraries />
          </Col>
        </Row>
      </section>
    </Container>
  );
};

export default Home;
